import {theme} from "./Tema";

export const GRADIENTE = 'linear-gradient(90deg, #8531FD 0%, #B996F9 100%)'

export const TIPODOCSREQ = ['Pdf', 'Imagen']

export const URLPAGINA = 'https://nebosystem.com/'

export const ESTADOSCOLECCIONES = [
    {
        nombre: 'Pulicada',
        color: '#796254'
    },
    {
        nombre: 'Archivada',
        color: '#808080'
    },
]

export const ESTADOSPRENDA = [
    {
        nombre: 'Pulicado',
        color: '#796254'
    },
    {
        nombre: 'Archivado',
        color: '#808080'
    },
]

export const ESTADOSUSUARIOS = [
    {
        nombre: 'Solicitante',
        color: '#5500d1'
    },
    {
        nombre: 'Admin',
        color: '#000000'
    },
    {
        nombre: 'Suspendido',
        color: theme.palette.info.main
    },
]


export const ESTADOSEVENTO = [
    {
        nombre: 'Publicado',
        color: '#5500d1'
    },
    {
        nombre: 'Archivado',
        color: '#000000'
    },

]


export const TIPOSIMULACIONCONSULTOR = [
    {
        nombre: 'Venta Directa',
        color: '#5500d1'
    },
    {
        nombre: 'Venta de mi consultor',
        color: '#000000'
    },

]


export const TIPOSIMULACIONDISTRIBUIDOR = [
    {
        nombre: 'Venta Directa',
        color: '#5500d1'
    },
    {
        nombre: 'Venta de mi Hijo',
        color: '#000000'
    },
    {
        nombre: 'Venta de mi Nieto',
        color: '#000000'
    },

]

export const TIPOSCONTENIDO = ['Video', 'Pdf', 'Imagen', 'Video YouTube']

export const RANGOSCUENTA = ['Consultor', 'Distribuidor']

export const  ITEMPASIVOS = [
    {
        nombre: 'D.I MASTER',
        tituloPrimero :'2 M,C',
        valorPrimero: 10000,
        uno: '1%',
        dos: '7%',
        tres: '5%',
        cuatro: '3%',
        cinco: '1',
        total: 800
    }
]
